if (!customElements.get('secondary-header')) {
  class SecondaryHeader extends HTMLElement {
    constructor() {
      super();
      this.detailsElements = [];
      this.boundOnDocumentClick = this.onDocumentClick.bind(this);
      this.boundOnKeyDown = this.onKeyDown.bind(this);
      this.boundPositionScrollDropdown = this.positionScrollDropdown.bind(this);
    }

    connectedCallback() {
      this.detailsElements = Array.from(this.querySelectorAll('details.secondary-header__details'));

      this.detailsElements.forEach((details) => {
        // Native <details> handles the open/close. We just coordinate siblings
        // and position the dropdown when the parent scrolls horizontally.
        details.addEventListener('toggle', (event) => {
          if (event.target.open) {
            this.closeOthers(event.target);
            this.positionScrollDropdown(event.target);
          }
        });

        // Close dropdown after tapping a child link (mobile UX nicety)
        const links = details.querySelectorAll('.secondary-header__dropdown-link');
        links.forEach((link) => {
          link.addEventListener('click', () => {
            details.open = false;
          });
        });
      });

      document.addEventListener('click', this.boundOnDocumentClick);
      document.addEventListener('keydown', this.boundOnKeyDown);
      window.addEventListener('resize', this.boundPositionScrollDropdown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundOnDocumentClick);
      document.removeEventListener('keydown', this.boundOnKeyDown);
      window.removeEventListener('resize', this.boundPositionScrollDropdown);
    }

    closeOthers(currentDetails) {
      this.detailsElements.forEach((details) => {
        if (details !== currentDetails && details.open) {
          details.open = false;
        }
      });
    }

    closeAll() {
      this.detailsElements.forEach((details) => {
        if (details.open) details.open = false;
      });
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeAll();
      }
    }

    onKeyDown(event) {
      if (event.key !== 'Escape') return;
      const anyOpen = this.detailsElements.some((d) => d.open);
      if (!anyOpen) return;
      const openDetails = this.detailsElements.find((d) => d.open);
      this.closeAll();
      if (openDetails) {
        const summary = openDetails.querySelector('summary');
        if (summary) summary.focus();
      }
    }

    // When in scroll mode the dropdown is position:fixed (so the parent's
    // overflow doesn't clip it). We set `top` based on the trigger's rect.
    positionScrollDropdown(arg) {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const isScroll = this.dataset.mobileLayout === 'scroll';
      if (!isMobile || !isScroll) return;

      const targets =
        arg instanceof HTMLDetailsElement
          ? [arg]
          : this.detailsElements.filter((d) => d.open);

      targets.forEach((details) => {
        const summary = details.querySelector('summary');
        const dropdown = details.querySelector('.secondary-header__dropdown');
        if (!summary || !dropdown) return;
        const rect = summary.getBoundingClientRect();
        dropdown.style.top = `${rect.bottom + 4}px`;
      });
    }
  }

  customElements.define('secondary-header', SecondaryHeader);
}